// Icons
import { ReactComponent as WordpressSite } from "../../../../AdminAssets/svg/WordpressSite.svg";
import { ReactComponent as CloneSite } from "../../../../AdminAssets/svg/CloneSite.svg";
import { ReactComponent as BlueprintSite } from "../../../../AdminAssets/svg/BlueprintSite.svg";
import { ReactComponent as BlankSite } from "../../../../AdminAssets/svg/BlankSite.svg";
import { ReactComponent as MigrateSite } from "../../../../AdminAssets/svg/MigrateSite.svg";
import { ReactComponent as PerformanceSite } from "../../../../AdminAssets/svg/PerformanceSite.svg";
// import { ReactComponent as SEOSite } from "../../../../AdminAssets/svg/SEOSite.svg";
import CyIcon from "../../../../../../GlobalAssets/PNG/CyIcon.png";
import Yoast from "../../../../../../GlobalAssets/PNG/Yoast.png";
import ElementorIcon from "../../../../../../GlobalAssets/JPG/elementor.jpg";

const STEP_ONE =
  "Start your journey to building a new site in just two easy steps.";
const STEP_TWO = "Set up your WordPress account login credentials.";
const STEP_THREE = "Verify your information before creating.";
const IN_PROGRESS_MESSAGE =
  "Your site is in progress! We’ll notify you once it’s ready.";
const COMPLETE_MESSAGE =
  "Congratulations! Your site has been successfully set up. You can now begin managing it through the dashboard or proceed with further configurations.";

export const SITE_MESSAGES = {
  newWordpressSite: {
    1: STEP_ONE,
    2: "A curated list of essential WordPress plugins to improve your website's performance and functionality.",
    3: STEP_TWO,
    4: STEP_THREE,
    5: {
      inProgress: IN_PROGRESS_MESSAGE,
      complete: COMPLETE_MESSAGE,
    },
  },
  cloneSiteHeader: {
    1: STEP_ONE,
    2: STEP_TWO,
    3: STEP_THREE,
    4: {
      inProgress: IN_PROGRESS_MESSAGE,
      complete: COMPLETE_MESSAGE,
    },
  },
  siteHeader: {
    1: STEP_ONE,
    2: STEP_TWO,
    3: STEP_THREE,
    4: {
      inProgress: IN_PROGRESS_MESSAGE,
      complete: COMPLETE_MESSAGE,
    },
  },
};

export const siteData = [
  {
    icon: WordpressSite,
    title: "New Wordpress Site",
    description:
      "Freshly created website using the WordPress platform for managing content.",
  },
  {
    icon: MigrateSite,
    title: "Migrate Site",
    description:
      "Migrating a site involves transferring it to a new hosting environment and removing it from the original setup once the transfer is complete.",
  },
  {
    icon: CloneSite,
    title: "Clone Site",
    description:
      "Content subfolders that help subdivide sections of your primary website.",
  },
  {
    icon: BlueprintSite,
    title: "Blueprint Site",
    description:
      "Extended part of your domain name that’s built for a specific purpose and acts as a separate site.",
  },
];

export const errorMessages = {
  "Migrate Site": "No sites available",
  "New Wordpress Site": "No sites available",
  "Clone Site": "No Clone Site available",
  "Blueprint Site": "No Blueprint Site available",
};

export const subHeaderMessages = {
  "Migrate Site":
    "Currently, you cannot migrate any sites because you have reached your maximum limit. To migrate a site, please upgrade your plan or remove an existing site.",
  "New Wordpress Site":
    "Currently, you cannot create a new WordPress site because you have reached your maximum limit. To add a site, please upgrade your plan or remove an existing site.",
  "Clone Site":
    "You cannot clone a site right now as there are no clone sites available. To clone a site, ensure you have at least one site that can be cloned under your current plan.",
  "Blueprint Site":
    "You cannot create a Blueprint Site because there are no Blueprint Sites available. To create blueprint site you have at least one blueprint.",
};

export const buttonText = {
  "New Wordpress Site": "Buy Plan",
  "Migrate Site": "Buy New Site",
  "Clone Site": "Create Site",
  "Blueprint Site": "Create Blueprint",
};

export const reachedMaximum = {
  title: "You Reached Maximun Limit",
  subTitle:
    "Currently, you cannot create site because you have reached your maximum limit. To add a site, please upgrade your plan or remove an existing site.",
  button: "Upgrade Plan",
};

export const selectedTypeData = [
  {
    title: "Blank site",
    description:
      "Add an empty WordPress site & A website accessible by one domain name and its sub-domains",
    icon: BlankSite,
  },
  {
    title: "Performance site",
    description:
      "Performance sites are high-speed, reliable websites optimized for smooth performance under heavy traffic.",
    icon: PerformanceSite,
  },
  // {
  //   title: "SEO Site",
  //   description:
  //     "Add an empty WordPress site & A website accessible by one domain name and its sub-domains",
  //   icon: SEOSite,
  //   comingSoon: true,
  // },
];

export const installationTypeData = [
  {
    title: "Single site",
    description: "A website accessible by one domain name and its sub-domains.",
    icon: BlankSite,
  },
  {
    title: "Multisite Sub-domain",
    description:
      "Extended part of your domain name that's built for a specific purpose.",
    icon: BlankSite,
  },
  {
    title: "Multisite Sub-directory",
    description:
      "Content subfolders that help subdivide sections of your primary website.",
    icon: BlankSite,
  },
];

export const PerformanceSites = {
  title: "Note",
  description:
    "You currently don't have a performance site. Purchase one to experience the benefits of a high-performance site.",
  description1:
    "You have reached the maximum limit of performance sites. To add a new one, please delete an existing site.",
  button: "Add Now",
};

export const migrationTypeData = [
  {
    title: "Self Migration",
    description: "Migrate using the Roocon Site Migration plugin.",
    time: "Estimation Time: 8 Hr",
  },
  {
    title: "Migrate via Backups",
    description: "Move your database and content on your own.",
    time: "Estimation Time: 8 Hr",
  },
  {
    title: "Request Expert Migration",
    description: "Migrate using the WP Engine Site Migration plugin.",
    time: "Estimation Time:  1-2 Business days",
  },
];

export const installationTypeMap = {
  "Single site": "Single Site",
  "Multisite Sub-domain": "Multisite Subdomain",
  "Multisite Sub-directory": "Multisite Subdirectory",
};

export const inputFields = (isInput, dedicatedHosting) => [
  { label: "Site Name", value: isInput.sitename },
  {
    label: "Temporary Domain Name",
    value: isInput.tempdomainname,
    suffix: isInput.tempdomainsuffix,
  },
  ...(!dedicatedHosting
    ? [
        {
          label: "WordPress Admin Username",
          value: isInput.wordpressusername,
          suffix: isInput.tempdomainname,
          showUnderscore: true,
        },
      ]
    : []),
];

export const environmentFields = (isInput) => [
  {
    label: "Temporary Domain Name",
    value: isInput.tempdomainnamedev,
    suffix: isInput.tempdomainsuffix,
  },
  {
    label: "WordPress Admin Username",
    value: isInput.wordpressusernamedev,
    suffix: isInput.tempdomainnamedev,
    showUnderscore: true,
  },
];

export const WordpressConstantText = {
  siteName: {
    header: "Site Name",
    subheader: "Assist in recognizing your platform. solely utilized in Rocon",
  },
  temporaryName: {
    header: "Temporary Domain Name ",
    subheader: "Visible at the top of every site page. Modifiable at any time.",
  },
  wordPressUsername: {
    header: "WordPress Admin Username",
  },
  wordPressPassword: {
    header: "WordPress Admin Password",
  },
  WAF: {
    header: "WAF (Web Application Firewall)",
    subheader:
      "Protects web applications by detecting and blocking malicious traffic.",
  },
  CDN: {
    header: "CDN (Content Delivery Network)",
    subheader:
      "Enhances speed, reliability, and efficiency of web content delivery.",
  },
};

export const EmptyStateCreateSite = {
  header: "Select a Plan to Begin",
  subHeader:
    "Choose a plan that suits your needs and unlock the tools to build, manage, and grow your WordPress site.",
  title: "Create your first",
  subTitle:
    "Get your WordPress site up and running quickly with our intuitive tools and robust hosting solutions. Choose a plan tailored to your organization and enjoy premium features, efficient site management, and the resources your team needs to succeed.",
};

export const plugins = [
  {
    imageSrc: CyIcon,
    header: "CookieYes",
    star: "4.8",
    subHeader:
      "Seamlessly integrate CookieYes on your website for automated consent management",
    readMore: "https://wordpress.org/plugins/cookie-law-info/",
    installValue: "cookie-law-info",
    visitSite: "https://www.cookieyes.com/get-cookieyes-rpp/",
  },
  {
    imageSrc: Yoast,
    header: "Yoast SEO",
    star: "4.8",
    subHeader: "SEO plugin that enhances website optimization",
    readMore: "https://wordpress.org/plugins/wordpress-seo/",
    installValue: "wordpress-seo",
    visitSite: "https://yoast.com/",
  },
  {
    imageSrc: ElementorIcon,
    header: "Elementor",
    star: "4.6",
    subHeader:
      "WordPress page builder that lets you design websites with drag-and-drop ease.",
    readMore: "https://wordpress.org/plugins/elementor/",
    installValue: "elementor",
    visitSite: "https://elementor.com/",
  },
];
export const getFilteredSiteData = (
  siteData,
  dedicatedHosting,
  isSingleSite
) => {
  if (dedicatedHosting || isSingleSite === true) {
    return siteData.filter(
      (item) => item.title !== "Clone Site" && item.title !== "Blueprint Site"
    );
  }
  return siteData;
};
